import { create } from 'zustand';

interface AudioStore {
    currentAudio: HTMLAudioElement | null;
    currentAudioId: string | null;
    playAudio: (audio: HTMLAudioElement, id: string) => Promise<void>;
    pauseCurrentAudio: () => void;
    setCurrentAudio: (audio: HTMLAudioElement, id: string) => void;
}

const useAudioStore = create<AudioStore>((set, get) => ({
    currentAudio: null,
    currentAudioId: null,

    playAudio: async (audio, id) => {
        const { currentAudio } = get();

        if (currentAudio && currentAudio !== audio) {
            currentAudio.pause();
            currentAudio.currentTime = 0;
        }

        try {
            // IMPORTANT: Don't reset currentTime before play on iOS - it breaks the user interaction context
            // Play immediately to preserve user gesture context
            const playPromise = audio.play();

            // Set state immediately after play() is called (not awaited)
            set({ currentAudio: audio, currentAudioId: id });

            // Now we can await the promise
            if (playPromise !== undefined) {
                await playPromise;
            }
        } catch (error) {
            console.error('Failed to play audio:', error);

            // If it's a NotAllowedError, user needs to interact again
            if (error instanceof Error && error.name === 'NotAllowedError') {
                console.warn('Audio playback requires user interaction');
            }

            throw error;
        }
    },

    pauseCurrentAudio: () => {
        const { currentAudio } = get();
        currentAudio?.pause();
    },

    setCurrentAudio: (audio, id) => {
        set({ currentAudio: audio, currentAudioId: id });
    }
}));

export default useAudioStore;

